// import { timediaUrl, urlTimediaSearch, timgestUrl } from '../config';

import * as Storage from "./Storage";
import { timediaUrl, youtubeUrl } from "../config";

// export const timediaUrl = localStorage.getItem('timediaUrl') == null ? 'https://ws.timothee.fr/timedia' : localStorage.getItem('timediaUrl');
export const coloUrl =
	localStorage.getItem("coloUrl") == null
		? "https://ws.timothee.fr/colo"
		: localStorage.getItem("coloUrl");
export const timgestUrl =
	localStorage.getItem("timgestUrl") == null
		? "https://ws.timothee.fr/timgest-api"
		: localStorage.getItem("timgestUrl");
export const urlTimediaSearch = timediaUrl + "/public/medias";

// const auth = 'cHVibGljOjk4SE85SE9JVUdPSTk4SA==';
export const tokenPublic = "cHVibGljOjk4SE85SE9JVUdPSTk4SA==";
export const tokenInscriptionTimgest =
	"MDk4SDA5OEgwOThIOThIUElIT1BJSDk4SDo5OEg5MDhIOTg3Rzk4R1VWS0pIVlNEVFhTNjc1RFNUUlhTNTRTU09JTTlVMDlKMTMy";

export const defaultHeaders = {
	Accept: "application/json",
	"Content-Type": "application/json",
	Authorization: "Basic " + tokenPublic
};
export const inscriptionHeaders = {
	Accept: "application/json",
	"Content-Type": "application/json",
	Authorization: "Basic " + tokenInscriptionTimgest
};

export const defaultParams = { headers: defaultHeaders };

let websitesUrl = `${timediaUrl}/websites/public`;

// Fake function
function test(pageName, self) {
	self.setState({
		content: pageName + " content",
		title: pageName + " title",
		metaTagKeyword: pageName + " keyword"
	});
}

export const getWebsite = self => {
	fetch(`${websitesUrl}/${window.location.hostname}/website`, defaultParams)
		.then(response => {
			if (response.status !== 200) {
				console.log("Error: " + response.status);
				return;
			}
			response.json().then(data => {
				self.setState({ website: data.data });
				// const { i18n } = self.props;
				// i18n.changeLanguage(data.data.defaultLangue.abreg);
			});
		})
		.catch(err => {
			self.setState({ loading: false, error: true });
			console.log(err);
		});
};

export const getNomWebsite = (self, callback) => {
	fetch(`${websitesUrl}/${window.location.hostname}/website`, defaultParams)
		.then(response => {
			if (response.status !== 200) {
				console.log("Error: " + response.status);
				return;
			}
			response.json().then(data => {
				callback(data);
			});
		})
		.catch(err => {
			self.setState({ loading: false, error: true });
			console.log(err);
		});
	// const response = await fetch(`${websitesUrl}/${window.location.hostname}/website`, defaultParams)
	// const json = await response.json();
	// const nomSimpl = json.data.nomSimpl.toUpperCase();
	// console.log(nomSimpl);
	// return nomSimpl;
};

export const getPageSite = (pageName, self, callback) => {
	fetch(`${websitesUrl}/${window.location.hostname}/${pageName}`, defaultParams)
		.then(response => {
			if (response.status !== 200) {
				console.log("Error: " + response.status);
				return;
			}
			response.json().then(data => {
				// console.log(data);
				self.setState(
					{
						pageSite: data.data,
						website: data.data.website
					},
					callback
				);
				// const { i18n } = self.props;
				// i18n.changeLanguage(data.data.website.defaultLangue.abreg);
			});
		})
		.catch(err => {
			self.setState({ loading: false, error: true });
			console.log(err);
		});
};

export const getFichiersOfPageSite = (pageName, self, callback) => {
	fetch(
		`${websitesUrl}/${window.location.hostname}/${pageName}/fichiers`,
		defaultParams
	)
		.then(response => {
			if (response.status !== 200) {
				console.log("Error: " + response.status);
				return;
			}
			response.json().then(data => {
				self.setState({ fichiers: data.data }, callback);
			});
		})
		.catch(err => {
			self.setState({ loading: false, error: true });
			console.log(err);
		});
};

export const getVideoYoutubeOfPageSite = (pageName, self) => {
	fetch(
		`${websitesUrl}/${window.location.hostname}/${pageName}/videoyoutubes`,
		defaultParams
	)
		.then(response => {
			if (response.status !== 200) {
				console.log("Error: " + response.status);
				return;
			}
			response.json().then(data => {
				self.setState({ videosYoutube: data.data });
			});
		})
		.catch(err => {
			self.setState({ loading: false, error: true });
			console.log(err);
		});
};

export const search = (filterSearch, self) => {
	fetch(urlTimediaSearch, {
		...defaultParams,
		method: "POST",
		body: JSON.stringify(filterSearch)
	})
		.then(response => {
			if (response.status !== 200) {
				console.error("Error: " + response.status);
				return;
			}
			response.json().then(data => {
				let receivedfilterSearch = data.filterSearch;
				for (var indice in filterSearch.filters) {
					let filter = filterSearch.filters[indice];
					let futureFilter;
					for (var futureIndice in receivedfilterSearch.filters) {
						if (
							receivedfilterSearch.filters[futureIndice].type === filter.type
						) {
							futureFilter = receivedfilterSearch.filters[futureIndice];
						}
					}
					if (futureFilter) {
						for (var itemIndice in filter.filterItems) {
							let item = filter.filterItems[itemIndice];
							if (futureFilter.filterItems) {
								for (var futureItem in futureFilter.filterItems) {
									if (futureFilter.filterItems[futureItem].id === item.id) {
										futureFilter.filterItems[futureItem].value = item.value;
									}
								}
							}
						}
					}
				}
				self.setState({
					filterSearch: receivedfilterSearch,
					data: data.data,
					quantityResult: data.quantityResult
				});
			});
		})
		.catch(err => {
			console.error(err);
		});
};

export const getMedia = (mediaId, self, callback) => {
	fetch(`${timediaUrl}/public/mediaFull/${mediaId}`, {
		...defaultParams,
		method: "GET"
	}).then(response => {
		if (response.status !== 200) {
			console.error("Error: " + response.status);
			return;
		}
		response.json().then(json => {
			self.setState(
				{
					media: json.data.media,
					auteurs: json.data.auteurs,
					fichiers: json.data.fichiers,
					livreBibles: json.data.livreBibles,
					mediaMedias: json.data.mediaMedias,
					videoYoutubes: json.data.videoYoutubes,
					fetchReceive: true
				},
				callback
			);
		});
	});
};

export const getMediaType = (mediaId, self, callback) => {
	fetch(`${timediaUrl}/public/mediaType/${mediaId}`, {
		...defaultParams,
		method: "GET"
	}).then(response => {
		if (response.status !== 200) {
			console.error("Error: " + response.status);
			return;
		}
		response.json().then(json => {
			self.setState(
				{
					mediaType: json.data
				},
				callback
			);
		});
	});
};

export const getVideos = (self, callback) => {
	fetch(`${timediaUrl}/public/videosCantiques`, {
		...defaultParams,
		method: "GET"
	}).then(response => {
		if (response.status !== 200) {
			console.error("Error: " + response.status);
			return;
		}
		response.json().then(json => {
			self.setState(
				{
					videoYoutubes: json.data
				},
				callback
			);
		});
	});
};

export const sendMessage = (message, self) => {
	fetch(`${websitesUrl}/sendMessage/timotheeaccueiljeunesse.fr/domaine`, {
		method: "POST",
		body: message,
		headers: defaultHeaders
	})
		.then(response => {
			if (response.status !== 200) {
				console.log("Error: " + response.status);
				return;
			}
			response.json().then(data => {
				self.setState({ success: data.success, swow: true });
				self.resetFields();
			});
		})
		.catch(err => {
			self.setState({ loading: false, error: true });
			console.log(err);
		});
};

export const sendMessageWithDomain = (message, self, nomDomaine) => {
	fetch(`${websitesUrl}/sendMessage/${nomDomaine}/domaine`, {
		method: "POST",
		body: message,
		headers: defaultHeaders
	})
		.then(response => {
			if (response.status !== 200) {
				console.log("Error: " + response.status);
				return;
			}
			response.json().then(data => {
				self.setState({ success: data.success, swow: true });
				self.resetFields();
			});
		})
		.catch(err => {
			self.setState({ loading: false, error: true });
			console.log(err);
		});
};

export const sendInscription = (message, self) => {
	fetch(`${timgestUrl}/public/createInscription`, {
		method: "POST",
		body: message,
		headers: inscriptionHeaders
	})
		.then(response => {
			if (response.status !== 200) {
				console.log("Error: " + response.status);
				return;
			}
			response.json().then(data => {
				self.setState({ success: data.success });
				self.handleShow(data.errorMessage);
				// self.resetFields();
			});
		})
		.catch(err => {
			// this.setState({ loading: false, error: true });
			console.log(err);
		});
};

export const sendInscriptionEquipe = (message, self) => {
	fetch(`${timediaUrl}/colonies/sendFormulaireEquipe`, {
		method: "POST",
		body: message,
		headers: defaultHeaders
	})
		.then(response => {
			if (response.status !== 200) {
				console.log("Error: " + response.status);
				return;
			} else {
				self.handleShow();
			}
			response.json().then(data => {
				// self.setState({ success: data.success });
				self.handleShow();
				// self.resetFields();
			});
		})
		.catch(err => {
			// this.setState({ loading: false, error: true });
			console.log(err);
		});
};

export const getCamps = (lieu, self, callback) => {
	fetch(`${timgestUrl}/public/getCampsForInscription/${lieu}`, {
		headers: inscriptionHeaders,
		method: "GET"
	}).then(response => {
		if (response.status !== 200) {
			console.error("Error: " + response.status);
			return;
		}
		response.json().then(json => {
			self.setState(
				{
					camps: json.data
				},
				callback
			);
		});
	});
};

export const getGallery = (idGallery, self, callback) => {
	fetch(`${timediaUrl}/public/gallery/${idGallery}`, {
		...defaultParams,
		method: "GET"
	}).then(response => {
		if (response.status !== 200) {
			console.error("Error: " + response.status);
			return;
		}
		response.json().then(json => {
			self.setState(
				{
					gallery: json.data
				},
				callback
			);
		});
	});
};

export const getReuDirect = (self, callback) => {
	fetch(`${timediaUrl}/public/reuDirect`, {
		...defaultParams,
		method: "GET"
	}).then(response => {
		if (response.status !== 200) {
			console.error("Error: " + response.status);
			return;
		}
		response.json().then(json => {
			self.setState(
				{
					annonceReuDirect: json.annonceReuDirect,
					lastRetransmissionReunionUrl: json.lastRetransmissionReunionUrl,
					acces: true
				},
				callback
			);
		});
	});
};

export const getBibleEnUnAn = (self, callback) => {
	fetch(`${timediaUrl}/public/bibleEnUnAn`, {
		...defaultParams,
		method: "GET"
	}).then(response => {
		if (response.status !== 200) {
			console.error("Error: " + response.status);
			return;
		}
		response.json().then(json => {
			self.setState(
				{
					date: json.date,
					titre: json.titre,
					lien: json.lien
				},
				callback
			);
		});
	});
};

export const getParleTonServiteurEcoute = (self, callback) => {
	fetch(`${timediaUrl}/public/parleTonServiteurEcoute`, {
		...defaultParams,
		method: "GET"
	}).then(response => {
		if (response.status !== 200) {
			console.error("Error: " + response.status);
			return;
		}
		response.json().then(json => {
			self.setState(
				{
					parleTonServiteurEcoute: {
						date: json.date,
						titre: json.titre,
						lien: json.lien
					}
				},
				callback
			);
		});
	});
};

export const getCommentaireNehemie = (self, callback) => {
	fetch(`${timediaUrl}/public/commentaireNehemie`, {
		...defaultParams,
		method: "GET"
	}).then(response => {
		if (response.status !== 200) {
			console.error("Error: " + response.status);
			return;
		}
		response.json().then(json => {
			self.setState(
				{
					commentaireNehemie: {
						date: json.date,
						titre: json.titre,
						lien: json.lien
					}
				},
				callback
			);
		});
	});
};

export const getSagesseProverbes = (self, callback) => {
	fetch(`${timediaUrl}/public/sagesseProverbes`, {
		...defaultParams,
		method: "GET"
	}).then(response => {
		if (response.status !== 200) {
			console.error("Error: " + response.status);
			return;
		}
		response.json().then(json => {
			self.setState(
				{
					sagesseProverbes: {
						date: json.date,
						titre: json.titre,
						lien: json.lien
					}
				},
				callback
			);
		});
	});
};

export const getGetMediasSimple = (nomRecherche, self, callback) => {
	fetch(`${timediaUrl}/public/mediasSimple/${nomRecherche}`, {
		...defaultParams,
		method: "GET"
	}).then(response => {
		if (response.status !== 200) {
			console.error("Error: " + response.status);
			return;
		}
		response.json().then(json => {
			console.log(json);
			self.setState(
				{
					medias: json.data
				},
				callback
			);
		});
	});
};

export const getGetVideosPlaylist = (idPlaylist, self, callback) => {
	fetch(`${youtubeUrl}/api/playlists/${idPlaylist}`, {
		...defaultParams,
		method: "GET"
	}).then(response => {
		if (response.status !== 200) {
			console.error("Error: " + response.status);
			return;
		}
		response.json().then(json => {
			console.log(json);
			self.setState(
				{
					videos: json.videos
				},
				callback
			);
		});
	});
};

export const getGetVideosInfos = idVideo => {
	fetch(`${youtubeUrl}/api/videos/${idVideo}/info`, {
		...defaultParams,
		method: "GET"
	}).then(response => {
		if (response.status !== 200) {
			console.error("Error: " + response.status);
			return;
		}
		response.json().then(json => {
			console.log(json);
			return json;
		});
	});
};

export const authentification = {
	isAuthenticated() {
		// if (localStorage.getItem("user") === null) {
		if (Storage.getUserParsed() === null) {
			return false;
		} else {
			return true;
		}
	},

	userHaveAuthorities(authorities) {
		return (
			(this.isAuthenticated() && this.hasRoles(authorities)) ||
			this.hasRoles(["ROLE_ADMIN"])
		);
	},

	hasRoles(values) {
		var retour = false;
		//var authorities = JSON.parse(localStorage.getItem("authorities"));
		var authorities = Storage.getAuthoritiesJson();
		if (authorities !== null) {
			values.forEach(function(value) {
				if (authorities.includes(value) || authorities.includes("ROLE_ADMIN")) {
					retour = true;
				}
			});
		}
		return retour;
	},

	locked(roles) {
		if (roles) {
			if (this.isAuthenticated()) {
				return !this.userHaveAuthorities(roles);
			} else {
				return false;
			}
		} else {
			return false;
		}
	}
};
